import { render, staticRenderFns } from "./ActivityLayout.vue?vue&type=template&id=4a0cc390&scoped=true&"
import script from "./ActivityLayout.vue?vue&type=script&lang=js&"
export * from "./ActivityLayout.vue?vue&type=script&lang=js&"
import style0 from "./ActivityLayout.vue?vue&type=style&index=0&id=4a0cc390&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0cc390",
  null
  
)

export default component.exports